import React from "react";
import {Grid,Card,CardContent,CardMedia,Typography} from '@mui/material';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const DashBoard=({videoList})=>
{
  const navigate=useNavigate();
 

return (
    <>
    <Grid container spacing={2} >
    {videoList?.map((video) =>
    {
        return(<Grid  item	xs={12}	sm={6}	md={4} lg={3}
          key={video._id} className="video-tile-link">
            <Link  to={`/video/${video._id}`} className="video-tile" >
            <Card 
            sx={{ maxWidth: 345,color:'#222222' }}
             onClick={() => navigate(`/video/${video._id}`)}
             className='video-tile'
            >
            <CardMedia
                component="img"
                height="140"
                image={video.previewImage}
                alt={video.title}
              />
              <CardContent sx={{maxHeight:24}} >
                <Typography gutterBottom component="div" sx={{color:'#FFFFFF',frontSize:'14px',fontWeight:'700'}}>
                  {video.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{frontSize:'14px',fontWeight:'400'}}>
                {video.releaseDate}
                </Typography>
              </CardContent>
            </Card>
            </Link>
            </Grid>)

    }
    )}

    </Grid>
    </>
)
}


export default DashBoard;
